export default __webpack_public_path__ + "static/media/47.c0a0a035.jpg";